import { report } from 'node:process';
import { DepartmentService } from './service/department.service';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { DepartmentInterface, ReportDepartmentInterface } from 'src/app/util/interfaces/department';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { ProfileService } from 'src/app/services/profile/profile.service';

@Component({
	selector: 'register-form-department',
	templateUrl: './department.component.html',
	styleUrls: ['./department.component.scss'],
})
export class DepartmentComponent implements OnInit {
	labels: any = {
		lbl_geral_salvar: 'Save',
		lbl_geral_departamentos: 'Departments',
		lbl_geral_depto: 'Department',
		lbl_geral_ativo: 'Active',
		lbl_status_desativado: 'Inactive',
		lbl_geral_departamento_nome_existente: 'Already have a department with that name',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_geral_departamento_atualizado_sucesso: 'Department updated successfully',
		lbl_geral_department_campos_redefinidos: 'All fields have been cleared',
		lbl_geral_departamento_campos_vazios_atualizar: 'Fill in the empty fields or search for a department to update',
		lbl_geral_departamento_desativada: 'Department has been disabled',
		lbl_geral_departamento_ativada: 'Department has been activated',
		lbl_departamento_cadastre_altere: 'The division is activated status',
		lbl_gerar_novo_department: 'New Department',
		lbl_geral_desativar: 'Inactivate',
		lbl_geral_ativar: 'Activate',
		lbl_selecione_departamento: 'select a website',
		lbl_geral_nome_completo: 'Full Name',
		lbl_email_completo: 'Full e-mail',
		lbl_geral_responsavel_departmento: 'Responsible for the department',
		lbl_geral_usuario_departmento: 'Users in this department',
		lbl_geral_nenhum_usuario: 'No users found',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_geral_usuario: 'Enduser',
		lbl_geral_nenhum_campo: 'No fields have been changed',
		lbl_bulletin_actions: 'actions',
		lbl_geral_motivo: 'Reason',
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'department', value: 'lbl_geral_departamentos', colType: 'text' },
		{ name: 'active', value: 'lbl_geral_ativo', colType: 'boolean' },
	];

	constructor(
		private NotificationService: NotificationService,
		private LabelsService: LabelsService,
		private DepartmentService: DepartmentService,
		private ProfileService: ProfileService
	) {}

	isLoadingLabels = true;
	isUpdating = false;
	isDisabling = false;

	userVisible = false;
	isButtonVisible: string | number;
	customDepartment: DepartmentInterface = {
		id: undefined,
		department: '',
		active: '',
		responsible_endusers: '',
		responsible: '',
		alteration: '',
		items: [],
	};

	// Departamento
	departmentList: DepartmentInterface[] = [];
	listDepartmentIAC: iacOptionInterface[] = [];
	isLoadingDepartment = true;
	clearValuesDepartment = false;
	department = {} as DepartmentInterface;

	// Responsável
	responsibleList: DepartmentInterface[] = [];
	listResponsibleIAC: iacOptionInterface[] = [];
	isLoadingResponsible = true;
	clearValuesResponsible = false;
	placeholderResponsible = '';
	unselectValue = true;

	searchTextReport: string;

	// logs
	isReportVisible = false;
	reportDepartmentoList: ReportDepartmentInterface[] = [];
	filteredReport: ReportDepartmentInterface[] = [];

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.getAllDepartment();
			this.labels = labels;
			this.isLoadingLabels = false;
			this.isReportVisible = true;
		});
	}

	getAllDepartment() {
		this.DepartmentService.getAllDepartment(this.ProfileService.userData().idCustomer).subscribe((res) => {
			this.listDepartmentIAC = [];
			this.departmentList = [];
			this.departmentList = res;
			for (const item of this.departmentList) {
				const newIacOptionDepartment: iacOptionInterface = {
					name: item.department,
					value: item.id,
					commonGroup: item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado,
				};
				this.listDepartmentIAC.push(newIacOptionDepartment);
			}
			this.isLoadingDepartment = false;
		});
	}

	//Get departamento
	getDepartment(id: string) {
		this.customDepartment.id = id;
		this.getAllResponsible();
		this.getReportDepartment(id);
		this.isReportVisible = false;
		this.DepartmentService.getDepartmentById(id).subscribe((data) => {
			this.customDepartment = data;
			this.customDepartment.department = data.department;
			this.customDepartment.alteration = data.alteration;
			this.customDepartment.items = data.items;
			this.customDepartment.alteration = '';
			this.isButtonVisible = this.customDepartment.active;
		});
	}

	getAllResponsible() {
		this.DepartmentService.getAllResponsible(this.customDepartment.id).subscribe((res) => {
			if (res.length === 0) {
				this.userVisible = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nenhum_usuario);
			} else {
				this.userVisible = true;
				this.listResponsibleIAC = [];
				this.responsibleList = [];
				this.responsibleList = res;
				for (const item of this.responsibleList) {
					const newIacOption: iacOptionInterface = {
						name: item.responsible,
						value: item.idFull_Name,
					};
					this.listResponsibleIAC.push(newIacOption);
				}
			}
			this.isLoadingResponsible = false;
		});
	}

	getResponsible(idResponsible: string) {
		this.DepartmentService.getResponsibleById(idResponsible).subscribe((data) => {
			this.customDepartment.idFull_Name = data.idFull_Name;
			this.customDepartment.responsible = data.responsible;
		});
	}

	// Salvar um departamento
	saveDepartment() {
		if (this.isUpdating || this.isDisabling) return;
		this.isUpdating = true;

		if (this.customDepartment.id === '') {
			this.DepartmentService.customDepartment(this.customDepartment).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_departamento_nome_existente);
				} else {
					this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.isLoadingDepartment = true;
					this.getAllDepartment();
					this.getReportDepartment;
					this.isLoadingDepartment = true;
				}
				this.isUpdating = false;
			});
		}
		if (this.customDepartment.id || '') {
			this.DepartmentService.updateDepartment(this.customDepartment).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nenhum_campo);
				}
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_departamento_atualizado_sucesso);
				this.isLoadingDepartment = true;
				this.getAllDepartment();
				this.getReportDepartment;
				this.getDepartment(this.customDepartment.id);
				this.isLoadingDepartment = true;
				this.isUpdating = false;
			});
		}
	}

	//
	searchReport() {
		this.filteredReport = this.reportDepartmentoList.filter((item) => {
			return (
				(item.email && item.email.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.date_time && item.date_time.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.alteration && item.alteration.toLowerCase().includes(this.searchTextReport.toLowerCase())) ||
				(item.changes && item.changes.toLowerCase().includes(this.searchTextReport.toLowerCase()))
			);
		});
	}

	// Desativar um departamento
	deleteDepartment(id: string) {
		if (this.isUpdating || this.isDisabling) return;
		this.isDisabling = true;

		if (this.customDepartment.department === '' || this.customDepartment.department === null) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		} else {
			this.DepartmentService.deleteDepartment(this.customDepartment).subscribe((data) => {
				this.getAllDepartment();
				this.isButtonVisible = 0;
				this.getDepartment(this.customDepartment.id);
				this.getReportDepartment;
				this.isLoadingDepartment = true;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_departamento_desativada);
				this.isDisabling = false;
			});
		}
	}

	// Ativar departamento
	activeDepartment(id: string) {
		if (this.isUpdating || this.isDisabling) return;
		this.isDisabling = true;

		if (this.customDepartment.department === '' || this.customDepartment.department === null) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		} else {
			this.DepartmentService.activeDepartment(this.customDepartment).subscribe((data) => {
				this.getAllDepartment();
				this.isButtonVisible = 1;
				this.getDepartment(this.customDepartment.id);
				this.getReportDepartment;
				this.isLoadingDepartment = true;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_departamento_ativada);
				this.isDisabling = false;
			});
		}
	}

	//Limpar Campos
	clearInputs(isNew: boolean) {
		this.clearValuesDepartment = true;
		setTimeout(() => {
			this.clearValuesDepartment = false;
		}, 1);

		this.clearValuesResponsible = true;
		setTimeout(() => {
			this.clearValuesResponsible = false;
		}, 1);

		// Remove o botão de desativação/ativação do form
		this.isButtonVisible = '';
		this.userVisible = false;

		this.customDepartment = {
			id: isNew ? '' : undefined,
			department: '',
			responsible: '',
			alteration: '',
		};
		this.isReportVisible = true;
	}

	// Validar Campo
	validateForm() {
		if (this.customDepartment.department === '' || this.customDepartment.department === null) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_departamento_campos_vazios_atualizar);
			return false;
		} else {
			this.saveDepartment();
		}
	}

	getReportDepartment(id) {
		this.DepartmentService.getReportDepartment(id).subscribe((departments) => {
			this.reportDepartmentoList = departments;
			this.filteredReport = departments;
		});
	}
}
